import { MetricTypes } from 'common/constants/metric-types';
import { MetricAttribution } from 'common/types/metric.models';

export function calculateRoasBase(cost: number, revenueValue: number) {
  return revenueValue && cost ? revenueValue / cost : 0;
}

export function calculateRoiBase(cost: number, revenueValue: number) {
  return revenueValue && cost ? revenueValue - cost : 0;
}

export function calculateCpaBase(cost: number, forms: number, calls: number) {
  const totalFormsAndCalls = forms + calls;
  return cost && totalFormsAndCalls ? cost / totalFormsAndCalls : 0;
}

export function calculateCpsBase(cost: number, sale: number) {
  return cost && sale ? cost / sale : 0;
}

export function calculateRoi(
  metrics: MetricAttribution[],
  metricTypeName: string
) {
  const cost = getMetric(metrics, metricTypeName, MetricTypes.COST);
  const revenue = getMetric(
    metrics,
    metricTypeName,
    MetricTypes.REVENUE_VALUES
  );
  return calculateRoiBase(cost, revenue);
}

export function calculateRoas(
  metrics: MetricAttribution[],
  metricTypeName: string
) {
  const cost = getMetric(metrics, metricTypeName, MetricTypes.COST);
  const revenue = getMetric(
    metrics,
    metricTypeName,
    MetricTypes.REVENUE_VALUES
  );
  return calculateRoasBase(cost, revenue);
}

export function calculateCpa(
  metrics: MetricAttribution[],
  metricTypeName: string
) {
  const cost = getMetric(metrics, metricTypeName, MetricTypes.COST);
  const forms = getMetric(metrics, metricTypeName, MetricTypes.WEB);
  const calls = getMetric(metrics, metricTypeName, MetricTypes.INBOUND_CALL);
  return calculateCpaBase(cost, forms, calls);
}

export function calculateCps(
  metrics: MetricAttribution[],
  metricTypeName: string
) {
  const cost = getMetric(metrics, metricTypeName, MetricTypes.COST);
  const sales = getMetric(metrics, metricTypeName, MetricTypes.REVENUES);
  return calculateCpsBase(cost, sales);
}

function getMetric(
  metrics: MetricAttribution[],
  metricTypeName: string,
  metricType: MetricTypes
): number {
  return (
    metrics.find(
      (metric) =>
        metric.metricTypeName === metricTypeName &&
        metric.metricType === metricType
    )?.attributionValue ?? 0
  );
}
